<template>
  <div @submit.prevent="verify">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="DownloadCloudIcon" class="mr-2" />
        <span class="font-medium text-lg leading-none">Dati importati tramite procedura automatica</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Chiave</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_chiave"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Denominazione</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_denom"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Cognome Nome</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_cognome_nome"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data pratica</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_data_pratica"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Tipo pratica</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_tipo_pratica"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Codice pratica</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_codice_pratica"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Tipo comunicazione</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_tipo_comunicazione"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Tipo contratto</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_tipo_contratto"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Unità locale</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_unita_locale"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data inizio rapporto</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_data_inizio_rapporto"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data fine rapporto</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_data_fine_rapporto"/>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Data fine periodo formativo</label>
        <vs-input :disabled="is_readonly" class="w-full" v-model="form.csv_data_fine_periodo_formativo"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  props: ['form','is_readonly'],
  components: {
  },

  data () {
    return {
      is_saving: false,
    }
  },

  methods: {
  },
}
</script>

<style lang="scss">
.con-input-upload .text-input {
  font-weight: normal;
  // font-style: italic;
}
</style>
